import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import CastingCommon from '@utils/casting-common';

// -------------------------------------------------------


const MAX_VIEW_COUNT = 7;

class ReportMembers extends React.Component {
  render() {
    let data = this.props.data;
    let list = Utils.createObjectToArray(data.workflow.influencers);
    list.map((d) => {
      d.view_order = 0;
      
      d.reports = [];
      d.contents_targets = [];
      
      // 投稿コンテンツ
      d.post_contents.map((c) => {
        let report = {};
        data.report.list.map((r) => { if( c.id == r.contents_id ) report = r; });
        
        // その他投稿
        if( Object.keys(report).length == 0 ){
          try { data.report.etc_list[c.id].map((r) => { if( d.insta_user_id == r.insta_user_id ) report = r; }); } catch(e) {}
        }
        
        // レポート化できない項目を除外
        let set_contents_type = {};
        Const.value.contents_type_list.map((t) => { if( t.id == c.media_type ) set_contents_type = t; });
        if( set_contents_type.report == false ) return;
        
        // レポート対象に設定
        d.contents_targets.push(Object.assign(c, { report: report }));
        
        if( Object.keys(report).length > 0 ){
          d.reports.push(report);
        } else {
          d.view_order += 1;
        }
      });
      
      if( d.post_contents.length > 0 ) d.view_order += 1;
      
      // 完了フラグ
      d.contents_complete = (d.contents_targets.length > 0 && d.reports.length == d.contents_targets.length);
      
      // 確認度が高い投稿
      d.request_action = CastingCommon.getRequestAction(data, d.insta_user_id);
      if( d.request_action == 'report_select' && d.contents_complete == false ) d.view_order += 99;
      
      return d;
    });
    list = Utils.sort(list, 'view_order');
    
    // 存在しない場合
    if( list.length == 0 ){
      return (
        <div className="report-members">
          <div className="report-none">インフルエンサーが登録されていません</div>
        </div>
      );
    }
    
    return (
      <div className="report-members">
        <ReportMembersList data={data} list={list} contents_type="report" title="実際の投稿を設定してください" />
        <ReportMembersList data={data} list={list} contents_type="contents" title="投稿種別を設定してください" />
      </div>
    );
  }
}
// -------------------------------------------------------

class ReportMembersList extends React.Component {
  render() {
    let data = this.props.data;
    let list = this.props.list.filter((d) => {
      if( this.props.contents_type == 'report' && d.contents_targets.length > 0 ) return d;
      if( this.props.contents_type == 'contents' && d.contents_targets.length == 0 ) return d;
    });
    
    if( list.length == 0 ) return null;
    
    list = list.map((d) => {
      d.score = (d.contents_targets.length - d.reports.length);
      if( d.reports.length == 0 ) d.score = -1;
      return d;
    });
    list = Utils.sort(list, 'score');
    
    return (
      <div className={'report-members-contents '+ this.props.contents_type}>
        <h3>{this.props.title}</h3>
        
        <ul className="members">
          { list.map((d, key) => {
            let flg = (d.contents_complete === true) ? 'on' : 'off';
            
            let pop_alert = CastingCommon.getReportSelectTarget(data, d.insta_user_id);
            
            // プロフィール
            let profile = (
              <div className="profile">
                <p>
                  <i className={'material-icons '+ flg}>check_circle</i><img src={d.thumbnail} />{d.insta_id}
                  { (pop_alert) && <span className="profile-dot" /> }
                </p>
              </div>
            );
            
            // 表示
            if( d.contents_targets.length == 0){
              return (
                <li key={key} onClick={data.event.showPostContents.bind(this, data.project.id, d.insta_user_id)}>
                  {profile}
                  <div className="contents-targets"><p className="none">投稿種別を設定していません</p></div>
                </li>
              );
            } else {
              return (
                <li key={key} onClick={data.event.showReportCandidateModal.bind(this, data.project.id, d.insta_user_id)}>
                  {profile}
                  <ReportMembersContents array={d.contents_targets} />
                  <InsightRemind data={d} base={data} />
                </li>
              );
            }
          })}
        </ul>
      </div>
    );
  }
}
// -------------------------------------------------------

class ReportMembersContents extends React.Component {
  render() {
    let array = this.props.array;
    if( array.length == 0 ) return null;
    array = Utils.sort(array, 'name', 'asc');
    
    let sort_result = [];
    Const.value.contents_type_list.map((c) => {
      array.map((d) => {
        if( d.media_type == c.id ) sort_result.push(d);
      });
    });
    
    return (
      <div className="contents-targets">
        { sort_result.map((d, key) => {
          if( key >= MAX_VIEW_COUNT ) return null;
          
          let set_date = null;
          let thumbnail = null;
          if( Object.keys(d.report).length > 0 ){
            try { thumbnail = (d.report.thumbnail != undefined) ? d.report.thumbnail : d.report.media_url; } catch(e) {}
            try { set_date = (d.report.post_date == null) ? d.report.register_date : d.report.post_date; } catch(e) {}
          }
          
          return (
            <div key={key} className="contents-targets-item">
              <h6>{d.name}</h6>
              
              { (thumbnail == null)
                ? <h2>-</h2>
                : <div className="image-thumbnail">
                    {(thumbnail != null && thumbnail.indexOf('.jpg') !== -1) ? <img src={thumbnail} onError={(e)=>{thumbnail}} /> : null }
                    {(thumbnail != null && thumbnail.indexOf('.png') !== -1) ? <img src={thumbnail} onError={(e)=>{thumbnail}} /> : null }
                    {(thumbnail != null && Utils.isVideo(thumbnail)) ? <video src={thumbnail} /> : null }
                  </div>
              }
              
              { (set_date != null) &&
                <h5>{Utils.setDate(set_date, 'M/D')}</h5>
              }
            </div>
          );
        })}
      </div>
    );
  }
}
// -------------------------------------------------------

class InsightRemind extends React.Component {
  changeAction(e) {
    e.stopPropagation();
    
    let data = this.props.data;
    
    Utils.request.bind(this)('/api/project/workflow/set_insight_remind', { project_id: this.props.base.project.id, insta_user_id: data.insta_user_id },
      function(res){
        this.props.base.event.refreshProject.bind(this)();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  insightFrame(e) {
    e.stopPropagation();
    return;
  }
  // -------------------------------------------------------
  
  cancelAction(e) {
    e.stopPropagation();
    
    let data = this.props.data;
    
    let chk = confirm('このアカウントのレポート対象から外してもよろしいですか？');
    if( chk == false ) return;
    
    let chk2 = confirm('下書きが含まれていた場合は、対象の下書きも削除されます。よろしいですか？\n※削除された下書きは復旧できません。ご注意ください。');
    if( chk2 == false ) return;
    
    Utils.request.bind(this)('/api/project/workflow/set_insight_cancel', { project_id: this.props.base.project.id, insta_user_id: data.insta_user_id },
      function(res){
        this.props.base.event.refreshProject.bind(this)();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    // インサイトリマインド
    let is_insight_reminder = 0;
    try { is_insight_reminder = data.status.is_insight_reminder } catch(e) {}
    
    if( data.reports.length == 0 ){
      return (
        <div className="insight-cancel" onClick={this.insightFrame.bind(this)}>
          <h6 onClick={this.cancelAction.bind(this)}>レポートから外す</h6>
        </div>
      );
    }
    
    return (
      <div className="insight-reminder" onClick={this.insightFrame.bind(this)}>
        <h6>インサイトのリマインド</h6>
        
        { (is_insight_reminder == 1)
          ? <p className="ok" onClick={this.changeAction.bind(this)}>する</p>
          : <p className="ng" onClick={this.changeAction.bind(this)}>しない</p>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ReportMembers;